import React from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../../../../systemUtils/MultiStyleButton";

const SupplierStep1Intro = ({ setCardStep }) => (
  <>
    <h1 className="card-title step1-title">Supplier System</h1>
    <p className="card-subtitle step1-subtitle">
      Suppliers can be contractors or companies that provide products or
      services to your company. They are registered to allow you to issue
      payment claims linked to suppliers.
    </p>
    <div className="continue-button-container">
      <MultiStyleButton
        label="Continue"
        buttonType="approve"
        onClick={() => setCardStep(2)}
      />
    </div>
  </>
);

SupplierStep1Intro.propTypes = {
  setCardStep: PropTypes.func.isRequired,
};

export default SupplierStep1Intro;
